module.exports = __webpack_public_path__ + "img/Home.2657d0ba.svg";